import * as React from "react";
import { ICourseInfo } from "./types";
import parse from "html-react-parser";
export const CourseInfo = React.memo(({ icon, title, description }: ICourseInfo) => {
  return (
    <div className="mini-window__course">
      <div className="mini-window__course__image">
        <img
          className={icon ? "" : "default"}
          src={icon ? `/media/280/${window.btoa(icon)}` : "/public/images/_anti/panel/lesson-default.png"}
          alt=""
          width="140"
        />
      </div>
      <div className="mini-window__course__name">{title}</div>
      <div className="br" />
      <div className="mini-window__course__description">
        {parse(description, {
          replace: function(domNode) {
            if (domNode.type === 'script') {
              var script = document.createElement('script');
              script.src = domNode.attribs.src;
              script.type = domNode.attribs.type;
              script.async = true;
              script.defer = true;
              document.head.appendChild(script);
            }
          }
        })}
      </div>
      <div className="br" />
    </div>
  );
});
